import { APP_PUBLIC_POSTHOG_HOST, APP_PUBLIC_POSTHOG_KEY } from "@config/posthog";
import { PostHogProvider } from "posthog-js/react";
import { FC, ReactNode } from "react";

const options = {
  api_host: APP_PUBLIC_POSTHOG_HOST,
};

export const PostHogProviderLayout: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <PostHogProvider apiKey={APP_PUBLIC_POSTHOG_KEY} options={options}>
      {children}
    </PostHogProvider>
  );
};
